module.exports = __webpack_public_path__ + "static/media/urbangoo11.4bce63b2.webp";